import { Component, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { LanguageService } from 'chronos-shared';
import { akitaDevtools, enableAkitaProdMode } from '@datorama/akita';

@Component({
  selector: 'pt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public title = 'chronos-pile-turner';

  constructor(private translate: TranslateService, private languageService: LanguageService, private ngZone: NgZone) {
    this.setTranslationLanguage();

    if (!environment.production) {
      akitaDevtools(ngZone);
    } else {
      enableAkitaProdMode();
    }
  }

  private setTranslationLanguage() {
    this.languageService.initCurrentDefaultLanguage(environment.defaultLanguage);
    this.languageService.language$.subscribe(async (lang) => {
      this.translate.setDefaultLang('en');
      await this.translate.use(lang).toPromise();

      if (lang === 'dbg') {
        this.translate.setDefaultLang(lang);
      }
    });
  }
}
